import { render, staticRenderFns } from "./SectionOpenChat.vue?vue&type=template&id=539d4651&scoped=true"
import script from "./SectionOpenChat.vue?vue&type=script&lang=js"
export * from "./SectionOpenChat.vue?vue&type=script&lang=js"
import style0 from "./SectionOpenChat.vue?vue&type=style&index=0&id=539d4651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d4651",
  null
  
)

export default component.exports